var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import styled from 'styled-components';
import theme from '@adsk/alloy-react-theme';
import { useLocale } from '@adsk/alloy-react-locale';
import Checkbox from '@adsk/alloy-react-checkbox';
import { ExpandButton } from '@adsk/alloy-react-tree';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import { countChildren } from '../../helpers/treeHelpers';
var NodeNameWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  width: 100%;\n  display: flex;\n  min-width: 0;\n"], ["\n  ", "\n  width: 100%;\n  display: flex;\n  min-width: 0;\n"])), __assign({}, theme.typography.bodyMedium));
NodeNameWrapper.displayName = 'NodeNameWrapper';
var NodeName = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: 0;\n  color: ", ";\n  flex: 1;\n  ", "\n"], ["\n  min-width: 0;\n  color: ", ";\n  flex: 1;\n  ", "\n"])), theme.colors.charcoal900, function (_a) {
    var isSelected = _a.isSelected;
    return isSelected
        ? __assign({}, theme.typography.bodyMediumBold) : __assign({}, theme.typography.bodyMedium);
});
NodeName.displayName = 'NodeName';
var NodeInfo = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  margin-left: 10px;\n"], ["\n  color: ", ";\n  margin-left: 10px;\n"])), theme.colors.charcoal700);
NodeInfo.displayName = 'NodeInfo';
var LocationTreeNode = function (_a) {
    var node = _a.node, multiple = _a.multiple, includeSubLocation = _a.includeSubLocation, ancestorsOfSelected = _a.ancestorsOfSelected, explicitlySelectedNodesIds = _a.explicitlySelectedNodesIds, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, _c = _a.isExpandable, isExpandable = _c === void 0 ? false : _c, _d = _a.isExpanded, isExpanded = _d === void 0 ? false : _d, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, onExpand = _a.onExpand;
    var T = useLocale(function (_a) {
        var locale = _a.locale;
        return require("../i18n/".concat(locale, ".json"));
    }).T;
    var isExplicitlySelected = explicitlySelectedNodesIds.includes(node.id);
    var numOfIncludedSubLocations = isExplicitlySelected && includeSubLocation ? countChildren(node) : 0;
    var numOfSelectedDescndants = useMemo(function () {
        var currentAncestorsOfSelected = Array.from(ancestorsOfSelected.values()).flat();
        return !includeSubLocation
            ? currentAncestorsOfSelected.filter(function (ancestorOfSelected) { return ancestorOfSelected === node.id; }).length
            : 0;
    }, [ancestorsOfSelected, includeSubLocation, node.id]);
    return (React.createElement(React.Fragment, null,
        isExpandable && (React.createElement(ExpandButton, { nonce: true, key: "expandIcon-".concat(node.id), style: {
                /* total width must equal indent unit of 30 */
                margin: '0 3px',
            }, isExpanded: isExpanded, onExpand: function (changes) { return onExpand === null || onExpand === void 0 ? void 0 : onExpand(__assign(__assign({}, changes), { id: node.id })); } })),
        multiple && (React.createElement(Checkbox, { style: { margin: '0 7px' }, "data-testid": "Checkbox", disabled: isDisabled, checked: isSelected })),
        React.createElement(NodeNameWrapper, null,
            React.createElement(NodeName, { isSelected: isExplicitlySelected },
                React.createElement(OverflowTooltip, { delayShow: 0, autoTipOnEllipsis: true, getTargetProps: function () { return ({ style: { minWidth: 0 } }); } }, node.name)),
            numOfIncludedSubLocations > 0 ? (React.createElement(NodeInfo, null, T.translate('locationPicker.numOfIncludedSubLocations', {
                numOfIncludedSubLocations: numOfIncludedSubLocations,
            }))) : null,
            numOfSelectedDescndants > 0 ? (React.createElement(NodeInfo, null, T.translate('locationPicker.numOfSelectedDescndants', {
                numOfSelectedDescndants: numOfSelectedDescndants,
            }))) : null)));
};
export default LocationTreeNode;
var templateObject_1, templateObject_2, templateObject_3;
